import { SquareIcon } from 'lucide-react'
import type { FC, ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface ChatInputStopButtonProps {
  onClick: () => void
  isStopping: boolean
}

/**
 * Stop button for the chat input toolbar.
 * Replaces the send button during active streaming to allow the user to cancel generation.
 */
export const ChatInputStopButton: FC<ChatInputStopButtonProps> = ({
  onClick,
  isStopping,
}): ReactNode => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        type="button"
        size="sm"
        variant="destructive"
        disabled={isStopping}
        onClick={onClick}
        className={cn('chat-stop-button gap-1.5 transition-all', isStopping && 'opacity-70')}
        aria-label={isStopping ? 'Stopping generation' : 'Stop generation'}
      >
        {isStopping ? (
          <span className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
        ) : (
          <SquareIcon className="size-4" />
        )}
        <span className="hidden sm:inline">{isStopping ? 'Stopping' : 'Stop'}</span>
      </Button>
    </TooltipTrigger>
    <TooltipContent side="top">
      {isStopping ? 'Stopping generation...' : 'Stop generation'}
    </TooltipContent>
  </Tooltip>
)

ChatInputStopButton.displayName = 'ChatInputStopButton'
